/**
 * The learn agent, full-screen at its own subdomain.
 *
 * Everything a sub-app needs — providers, auth gate, login bounce, i18n,
 * async-turn delivery, the route table — is the platform's AgentApp. What is
 * this agent's own is exactly what it passes: its root screen and its
 * full-screen conversation screen.
 *
 * No route tree of its own: the runner and curriculum-path routes died with
 * the training run (a run is a conversation; the conversation domain is
 * tricorder-session's from the cut-over on). The board reads
 * learning-service directly and opens nothing below itself.
 */
import { AgentApp } from '@frontend/components/agentDetail/AgentApp'

import Home from './pages/Home'
import Session from './pages/Session'

export default function App() {
  return <AgentApp home={<Home />} sessionScreen={<Session />} />
}
